import Container from '@/app/_components/container';
import Image from 'next/image';
import { DAVINCI_CDN } from '@/costants/defaultValues';
import { sanitizeImageUrl } from '@/utils/images';

type ProfileHeaderProps = {
  imageSrc?: string | null;
  altText?: string | null;
};

const ProfileHeader = ({ imageSrc, altText }: ProfileHeaderProps) => (
  <div className="relative">
    <div className="relative h-24 lg:h-44">
      <Image src={`${DAVINCI_CDN}/elty/elty-struttura-cover.jpg`} alt="cover image" className="object-cover" fill loading="eager" />
    </div>
    {imageSrc && (
      <div className="absolute inset-0 mt-4 lg:mt-8">
        <Container>
          <div className="relative flex h-24 w-24 items-center justify-center overflow-hidden rounded-full border border-brandBlue-200 bg-neutral-surface shadow-md lg:h-40 lg:w-40">
            <Image
              src={sanitizeImageUrl(imageSrc)}
              alt={altText ?? 'profile image'}
              data-cy="profile image"
              className="object-contain"
              fill
            />
          </div>
        </Container>
      </div>
    )}
  </div>
);

export default ProfileHeader;
